import { Injectable } from "@angular/core";
import { OfferType } from "../../../../models/offer.model";
import { OfferSummaryWidgetData } from "./models/offer-summary-widget-data.model";
import { ApplicationOffer, ApplicationOfferBundleData } from "../../../../../application/application.model";
import { ProductCode } from "../../../../../product/product.model";
import { getProductHeading } from "../../../../models/large-loan-program.model";
import { getOfferTermLabel } from "../../../../pipes/offer-term-label-pipe";

@Injectable()
export class OfferSummaryWidgetFacade {
  initData(
    offerBundle: ApplicationOfferBundleData,
    largeLoanProgramOffered: boolean
  ): OfferSummaryWidgetData {
    const offers = offerBundle?.offers;
    if (!offers || offers.length === 0) {
      return null;
    }

    const offer = offers?.[0];
    const offerType = this.getOfferType(offer.productCode);
    const heading = getProductHeading(offerBundle, offer.productName, largeLoanProgramOffered);

    return {
      offerType: this.getOfferType(offer.productCode),
      amountTitle: this.getAmountTitle(offerType),
      amount: this.getAmount(offers),
      productLabel: heading.label,
      productName: heading.title,
      repaymentTermLabel: getOfferTermLabel(offer.repaymentTerm),
      isLargeLoanProgram: heading.isLargeLoanProgram,
    };
  }

  private getOfferType(productCode: ProductCode): OfferType {
    switch (productCode) {
      case ProductCode.LOC:
        return OfferType.LOC;
      case ProductCode.Term:
        return OfferType.Term;
      case ProductCode.Law:
        return OfferType.Law;
    }
  }

  private getAmountTitle(offerType: OfferType): string {
    switch (offerType) {
      case OfferType.Term:
        return "Loan amount";
      case OfferType.LOC:
      case OfferType.Law:
        return "Credit limit";
    }
  }

  private getAmount(offers: ApplicationOffer[]) {
    return offers.reduce((acc, item) => {
      return (acc += item.amount);
    }, 0);
  }
}
